import React from 'react';
import "../../../assets/css/common/AllCss.css";
import "../../../assets/css/common/Swiper.css";
import config from '../../../assets/js/conf/config.js';
import {request, fnTokenError} from '../../../assets/js/libs/request.js';
import {lazyImg, setScrollTop} from '../../../assets/js/utils/util.js';		//图片懒加载	
import UpRefresh from "../../../assets/js/libs/uprefresh.js";


export default class collegeComponent extends React.Component{
	constructor(){
		super();
		this.state = {
			Screen: false,
			fenyuanArr: [],
			zhibo: null,
			keywords: ''
		};
		this.Screen = true;
		this.oUpRefresh = null;
		this.curPage = 1;
		this.maxPage = 0;
		this.offsetBottom = 50;
	}
    componentDidMount(){
    	this.getJson();
    }
    getJson(){
    	this.refs.keywords.blur();
    	let data = {
    		"param": {
			    "keyword": this.state.keywords
			},
			"pageIndex": 1,
			"pageSize": 10
    	}
    	request(config.baseUrl+'api/Study/S010', 'post', data).then(res=>{
            if (res.code === 0){
                this.setState({
                	fenyuanArr: res.data.items
                })
                this.maxPage = res.data.totalItems;
				this.getScrollPage();
            }
        });
    }
    getScrollPage() {
		this.oUpRefresh = new UpRefresh({
			"curPage": this.curPage,
			"maxPage": this.maxPage,
			"offsetBottom": this.offsetBottom
		}, curPage => {
			if((curPage-1) * 10 >= this.maxPage){
				return
			}
			let data = {
	    		"param": {
				    "keyword": this.state.keywords
				},
				"pageIndex": curPage,
				"pageSize": 10
	    	}
			request(config.baseUrl+'api/Study/S010', 'post', data).then(res=>{
	            if (res.data.items.length>0){
	            	let searchArr = this.state.fenyuanArr;
					for(let i = 0; i < res.data.items.length; i++) {
						searchArr.push(res.data.items[i]);
					}
					this.setState({
						fenyuanArr: searchArr
					})
	            }
	       });
		})
	}
    componentWillUnmount(){
    	//界面离开的时候
		this.Screen = false;
		this.setState=(state,callback)=>{
            return;
        }
		window.removeEventListener("scroll", this.isScren.bind(this));
	}
    isScren(){
    	if(this.Screen){
    		let isScreen = document.documentElement.scrollTop || document.body.scrollTop;
    		global.scrollTop.index = isScreen;
	    	if(isScreen>=100){
	    		this.setState({
	    			Screen : true
	    		});
	    	}else{
	    		this.setState({
	    			Screen : false
	    		});
	    	}
    	}
    }
    LeftIcon(path){
    	this.props.history.push(path)
    }
    pushPage(){
    	this.props.history.push('/notfind');
    }
    render(){
        return(
            <div className={'college'}>
                <div className={this.state.Screen?'search-header search-header red-bg':'search-header search-header'}>
	                <div className={'search-wrap'}>
                        <div className={'search-icon'}></div>
                        <div className={'search-text'}>
                        	<form action='' onSubmit={this.getJson.bind(this)}>
                        		<input type="search" className={'collegeInput'} placeholder="搜索" ref='keywords' defaultValue={this.state.defaultValue} onChange={(e)=>{this.state.keywords=e.target.value}} />
						    </form>
                        </div>
                    </div>
                    <div className={'login-wrap'}>
                        <div className={'my'} onClick={this.pushPage.bind(this)}>
                        	<span className={'mesSpan hide'}>10</span>
                        </div>
                    </div>
                </div>
                <div className={"college-TopImg"}>
    				<img src={require('../../../assets/images/video/zs.png')} alt='图片' />
				</div>
                <div className={this.state.zhibo?'found':'hide'}>
                	<div className={'found-title-wrap'}>
                		{
//              			<div className={'found-title'}>正在直播</div>
//              		<div className={'found-item0'}>
//              			<div className={'found-img0'}>
//                          	<img  data-echo={require('../../../assets/images/home/index/banner_5.jpg')} />
//                          </div>
//                          <div className={'found-txt'}>
//	                            <div className={'found-title0'}>人在线人在线人在线人在线人在线人在线人在线人在线人在线</div>
//	                            <div className={"found-text0"}>人在线人在线人在线人在线人在线人在线人在线人在线人在线在线人在线在线人在线</div>
//	                            <div className={"found-text-foot"}>
//	                            	<div className={"found-text-foot-nub"}>0人在线</div>
//	                            	<div className={"found-text-foot-btn"}>进入直播</div>
//	                            </div>
//                          </div>
//                      </div>
                		}
                		
                	{
                		this.state.zhibo?
                		<React.Fragment>
	                		<div className={'found-title zhibo'}>正在直播</div>
	                		<div className={'found-item0'} onClick={this.LeftIcon.bind(this,  '/video/detail?olId='+(this.state.zhibo!=null?this.state.zhibo.merchandiseId:''))}>
	                			<div className={'found-img0'}>
	                            	<img alt={this.state.zhibo!=null?this.state.zhibo.Ol_Name:''} data-echo={this.state.zhibo.Ol_Logo != ''?this.state.zhibo.Ol_Logo:require('../../../assets/images/home/index/banner_5.jpg')} />
	                            </div>
	                            <div className={'found-txt'}>
		                            <div className={'found-title0'}>{this.state.zhibo!=null?this.state.zhibo.Ol_Name:''}</div>
		                            <div className={"found-text0"}>{this.state.zhibo!=null?this.state.zhibo.Ol_Intro:''}</div>
		                            <div className={"found-text-foot"}>
		                            	<div className={"found-text-foot-nub"}>{this.state.zhibo!=null?this.state.zhibo.Ol_LookCount:'0'}人在线</div>
		                            	<div className={"found-text-foot-btn"}>进入直播</div>
		                            </div>
	                            </div>
	                        </div>
                        </React.Fragment>
                        :''
                	}
                	</div>
                </div>
                <div className={'found'} style={{backgroundColor: this.state.fenyuanArr.length>0?'':'transparent'}}>
                	<div className={'found-title-wrap'}>
                	{
                		this.state.fenyuanArr.length>0?
                		this.state.fenyuanArr.map((item2,index2) => {
                			return(
                				<div className={'found-item0 col'} onClick={this.LeftIcon.bind(this, '/video/detail?olId='+item2.outLine.merchandiseId)} key={index2}>
		                			<div className={'found-img0'}>
		                            	<img src={item2.outLine.Ol_Logo != ""?item2.outLine.Ol_Logo:require('../../../assets/images/video/pic_cover.png')} />
		                            </div>
		                            <div className={'found-txt'}>
			                            <div className={'found-title0'}>{item2.outLine.Ol_Name}</div>
			                            <div className={"found-text0"}>{item2.outLine.TeacherName}</div>
		                            </div>
		                        </div>
                			)
                		})
                        :<div className={"null"}>
                        	<img src={require('../../../assets/images/video/wu.png')} />
                        	<div>暂无内容!</div>
                        </div>
                	}
                	<div style={{height: 1.5+'rem'}}></div>
                		
                	</div>
                </div>
            </div>
        );
    }
}